/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Tippy {
    angular.module("meevo.plugins.tippy", []);
}